import React from "react";

function CasualContact() {
  return (
    <div className="body-content">
      <div class="letters-color-section">
        <div class="main_header">Hire a Bus</div>
        <div class="main-container">
          <div class="main-header-bus">
            <span class="new-bus">NEW</span> Updated Information is published on
            ksrtc.karnataka.gov.in{" "}
            <a class="href-link" href="">
              Click Here
            </a>{" "}
            to View
          </div>
        </div>
      </div>
    </div>
  );
}

export default CasualContact;
